import {useMemo} from 'react'
import {useSubscription} from 'react-relay'
import type {GraphQLSubscriptionConfig} from 'relay-runtime'
import {graphql} from 'relay-runtime'

import type {ParentIssueSubscription} from './__generated__/ParentIssueSubscription.graphql'

// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
const subscription = graphql`
  subscription ParentIssueSubscription($issueId: ID!) {
    issueUpdated(id: $issueId) {
      # This could be made more efficient by splitting the fragment into subparts, but it's already pretty small
      issueStateUpdated {
        ...ParentIssueFragment
        ...HeaderParentTitle
      }
      issueTitleUpdated {
        ...ParentIssueFragment
        ...HeaderParentTitle
      }
      subIssuesSummaryUpdated {
        ...useSubIssuesSummary @arguments(fetchSubIssues: false)
      }
    }
  }
`

export const useParentIssueSubscription = (issueId: string) => {
  const config = useMemo<GraphQLSubscriptionConfig<ParentIssueSubscription>>(
    () => ({
      variables: {issueId},
      subscription,
    }),
    [issueId],
  )

  useSubscription(config)
}
